//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopHeader from './_header'


import TopFilter from '@/components/buildings_top_filter/index'
import ListLoading from '@/components/views/loading'
import BuildingItem from '@/components/business/whole_building_item'
import RecommendedBuildings from '@/components/business/recommended_buildings'

import TagFilter from './_tag_filter'
import Recommendation from './_recommendation'
import SwiperBanner from './_swiper'

import PageTopFilter from '@/common/tpl/mixins/page_top_filter'
import Pagination from '@/common/mixins/pagination'

import API from '@/service/whole_buildings'
import PublicAPI from '@/service/public'
import BottomTip from '@/components/views/bottom_tip'
import { BUILDING_STATUS } from '@/constant'
import BackToTop from '@/components/views/back_to_top'
import { getLocation } from '@/data/location'
import page_log from '@/common/mixins/page_log'


const RECOMMEND_TYPE = {
    '': 'seek_list',
    '即将预售': 'seek_forthcoming_sale_list',
    '热门楼盘': 'seek_hot_list'
}


const PAGE_STATE = {
    filter_change: false
}

export default {
    mixins: [
        PageTopFilter,
        Pagination,
        page_log({ page_name: '找房' }),
    ],
    data () {
        return {
            recomended_building: null,
            filter_tabs: ['区域', '价格', '户型', '面积', '装修'],
            status: '',
            decoration: '',
            zone_ids: '',
            area: '',
            total_price: '',
            price: '',
            layout: '',
            ring_road: '',
            metro: '',
            recommendation: [],
            recommend: false,
            location: '',
            disatance: 0,
            seek_building_popup_show: false
        }
    },
    components: {
        SwiperBanner,
        RecommendedBuildings,
        TopHeader,
        TopFilter,
        TagFilter,
        Recommendation,
        ListLoading,
        BuildingItem,
        BackToTop,
        BottomTip,
    },
    computed: {
        show_recommendation () {
            return [
                'decoration',
                'zone_ids',
                'zone_section_ids',
                'area',
                'total_price',
                'price',
                'layout',
                'metro',
                'location',
                'disatance'
            ].every(key => !this[key])
        }
    },
    watch: {
        filter_show (latest, old) {
            if (latest && latest != old) {
                this.checkTopFilterPosition()
            }
        }
    },
    mounted () {
        this.getRecommendedBuildings()
        this.getRecommendation()
    },
    methods: {
        async getRecommendedBuildings() {
            const data = await API.getRecommendedBuildings({
                page: 1,
                per: 5
            })
            this.recomended_building = data
        },
        checkTopFilterPosition () {
            window.scrollTo({ top: document.getElementById('filter-top').offsetTop })

        },
        searchClick () {
            wx.navigateTo({
                url: '/pages/index/search/main'
            })
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.page = 1
            this.getData()
        },
        changeStatus (status) {
            this.status = status
            this.page = 1
            if (this.show_recommendation) {
                this.getRecommendation()
            } else {
                this.getData()
            }
        },
        getRecommendation () {
            const position = RECOMMEND_TYPE[this.status]
            this.loading = true
            this.items = []
            this.recommendation = []
            if (position) {
                PublicAPI.getRecommendation(position, {})
                    .then((data) => {
                        if (data && data.length) {
                            this.recommendation = data
                        }
                        this.getData()
                    })
            } else {
                this.getData()
            }
        },
        getData () {
            this.loading = true
            const opt = {
                page: this.page
            }
            const filter_keys = [
                'decoration',
                'zone_ids',
                'zone_section_ids',
                'area',
                'total_price',
                'price',
                'layout',
                'metro',
                'status',
                'location',
                'distance',
                'ring_road'
            ]
            let has_filter = false
            filter_keys.forEach((key) => {
                if (this[key]) {
                    opt[key] = this[key]
                    has_filter = true
                }
            })
            if (this.show_recommendation) {
                opt.exclude_ids = this.recommendation.map(({ building_id }) => building_id).join(',')
            }
            opt.status = opt.status ? BUILDING_STATUS[opt.status] : ''
            API.list(opt).then(({ items, recommend, total_count }) => {
                this.recommend = recommend
                this.handleData({ items })
                if (this.page === 1 && has_filter && !recommend && total_count) {
                    wx.showToast({
                        title: `共找到${total_count}个楼盘`,
                        icon: 'none'
                    })
                }
            }).then(() => {
                PAGE_STATE.filter_change = true
                this.$nextTick(this.listenListShow)
            })
        },
        onCheckNewUser(show) {
            this.seek_building_popup_show = !show
        }
    }
}
